export function cleanTailoredTask(tailored, original) {
    const updatedTailored = {}
    for (const [key, newVal] of Object.entries(tailored)) {
        const oldVal = original[key]
        // Skip undefined new values
        if (newVal === undefined) continue

        switch (key) {
            case "skill":
                if (newVal?.SkillingCode !== oldVal?.SkillingCode) {
                    updatedTailored.skill = newVal
                }
                break
            case "minutes":
                // Skip if null/undefined mismatch (null <-> undefined)
                if (!((newVal === null && oldVal === undefined) || (newVal === undefined && oldVal === null))) {
                    if (newVal !== oldVal) updatedTailored.minutes = newVal
                }
                break
            default:
                if (newVal !== oldVal) {
                    updatedTailored[key] = newVal
                }
        }
    }
    return updatedTailored
}
